var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.distributor == "ITALY_HINTIME" ||
    _vm.distributor == "SAU_EMS20" ||
    _vm.distributor == "MX_30FIT"
    ? _c(
        "div",
        {
          staticClass: "page-container",
          staticStyle: {
            width: "99%",
            "margin-top": "15px",
            position: "absolute"
          }
        },
        [
          _c(
            "el-row",
            {
              staticStyle: {
                display: "flex",
                width: "100%",
                "margin-top": "10px"
              },
              attrs: { gutter: 12 }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-card",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _c("div", { staticClass: "card-header" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("elLocal.userTongji")))
                                  ])
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        1222394467
                      )
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.users,
                                "header-cell-style": { background: "#00000005" }
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "todayCreate",
                                  label: _vm.$t("elLocal.todayCreate"),
                                  "min-width": "20%",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "mouthCreate",
                                  label: _vm.$t("elLocal.mouthCreate"),
                                  "min-width": "20%",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _vm.distributor != "SAU_EMS20"
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "todayActiv",
                                      label: _vm.$t("elLocal.todayActiv"),
                                      "min-width": "20%",
                                      align: "center"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.distributor != "SAU_EMS20"
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "mouthActiv",
                                      label: _vm.$t("elLocal.mouthActiv"),
                                      "min-width": "20%",
                                      align: "center"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "allCreate",
                                  label: _vm.$t("elLocal.allCreate"),
                                  "min-width": "20%",
                                  align: "center"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.distributor != "SAU_EMS20"
            ? _c(
                "el-row",
                {
                  staticStyle: {
                    display: "flex",
                    width: "100%",
                    "margin-top": "10px"
                  },
                  attrs: { gutter: 12 }
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-card",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function() {
                                  return [
                                    _c("div", { staticClass: "card-header" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("elLocal.deviceTongji"))
                                        )
                                      ])
                                    ])
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1749974346
                          )
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.devices,
                                    "header-cell-style": {
                                      background: "#00000005"
                                    }
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "todayCreate",
                                      label: _vm.$t(
                                        "elLocal.todayCreateDevice"
                                      ),
                                      "min-width": "20%",
                                      align: "center"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "mouthCreate",
                                      label: _vm.$t(
                                        "elLocal.mouthCreateDevice"
                                      ),
                                      "min-width": "20%",
                                      align: "center"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "todayActiv",
                                      label: _vm.$t("elLocal.todayActivDevice"),
                                      "min-width": "20%",
                                      align: "center"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "mouthActiv",
                                      label: _vm.$t("elLocal.mouthActivDevice"),
                                      "min-width": "20%",
                                      align: "center"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "allCreate",
                                      label: _vm.$t("elLocal.allCreate"),
                                      "min-width": "20%",
                                      align: "center"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-row",
            {
              staticStyle: {
                display: "flex",
                width: "100%",
                "margin-top": "10px"
              },
              attrs: { gutter: 12 }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-card",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _c("div", { staticClass: "card-header" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("elLocal.sexTongji")))
                                  ])
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3028564508
                      )
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.userSex,
                                "header-cell-style": { background: "#00000005" }
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sex",
                                  label: _vm.$t("elLocal.sex"),
                                  "min-width": "33%",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.sex == 0
                                                  ? _vm.$t("elLocal.sexNan")
                                                  : scope.row.sex == 1
                                                  ? _vm.$t("elLocal.sexNvn")
                                                  : _vm.$t("elLocal.unkown")
                                              )
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  630770765
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "c",
                                  label: _vm.$t("elLocal.percentage"),
                                  "min-width": "33%",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                (
                                                  (scope.row.c * 100) /
                                                  _vm.userAll
                                                ).toFixed(2)
                                              ) + "%"
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2880706430
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "c",
                                  label: _vm.$t("elLocal.quantity"),
                                  "min-width": "33%",
                                  align: "center"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-card",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _c("div", { staticClass: "card-header" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("elLocal.ageTongji")))
                                  ])
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2730505713
                      )
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.userAge,
                                "header-cell-style": { background: "#00000005" }
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "age",
                                  label: _vm.$t("elLocal.age"),
                                  "min-width": "33%",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.age == "--"
                                                  ? _vm.$t("elLocal.unkown")
                                                  : scope.row.age
                                              )
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2734146078
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "c",
                                  label: _vm.$t("elLocal.percentage"),
                                  "min-width": "33%",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                (
                                                  (scope.row.c * 100) /
                                                  _vm.userAll
                                                ).toFixed(2)
                                              ) + "%"
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2880706430
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "c",
                                  label: _vm.$t("elLocal.quantity"),
                                  "min-width": "33%",
                                  align: "center"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-card",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _c("div", { staticClass: "card-header" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("elLocal.areaTingji")))
                                  ])
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3671565091
                      )
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.userArea,
                                "header-cell-style": { background: "#00000005" }
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "country",
                                  label: _vm.$t("elLocal.area"),
                                  "min-width": "50%",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                !scope.row.country ||
                                                  scope.row.country == null
                                                  ? _vm.$t("elLocal.unkown")
                                                  : scope.row.country
                                              )
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3240710252
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "c",
                                  label: _vm.$t("elLocal.percentage"),
                                  "min-width": "25%",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                (
                                                  (scope.row.c * 100) /
                                                  _vm.userAll
                                                ).toFixed(2)
                                              ) + "%"
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2880706430
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "c",
                                  label: _vm.$t("elLocal.quantity"),
                                  "min-width": "25%",
                                  align: "center"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.distributor == "SAU_EMS20"
            ? _c(
                "el-row",
                {
                  staticStyle: {
                    display: "flex",
                    width: "100%",
                    "margin-top": "10px"
                  },
                  attrs: { gutter: 12 }
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-card",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function() {
                                  return [
                                    _c("div", { staticClass: "card-header" }, [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("elLocal.shouru")))
                                      ])
                                    ])
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            3190483461
                          )
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.sessions,
                                    "header-cell-style": {
                                      background: "#00000005"
                                    }
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "todayCreate",
                                      label: _vm.$t("elLocal.todayCreateSales"),
                                      "min-width": "20%",
                                      align: "center"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.todayCreate)
                                                )
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3298655748
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "weekCreate",
                                      label: _vm.$t("elLocal.weekCreateSales"),
                                      "min-width": "20%",
                                      align: "center"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.weekCreate)
                                                )
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      967621855
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "mouthCreate",
                                      label: _vm.$t("elLocal.mouthCreateSales"),
                                      "min-width": "20%",
                                      align: "center"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.mouthCreate)
                                                )
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1532576168
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "yearCreate",
                                      label: _vm.$t("elLocal.yearCreateSales"),
                                      "min-width": "20%",
                                      align: "center"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.yearCreate)
                                                )
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1109142316
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "allCreate",
                                      label: _vm.$t("elLocal.allCreate"),
                                      "min-width": "20%",
                                      align: "center"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.allCreate)
                                                )
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1888725186
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8f8c7c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8f8c7c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Intro/Intro.vue
// module id = null
// module chunks = 